import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const tags = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            // skip: 0,
            // take: 200,
            // total: 0,
            // page: 1,
            groupID: null,
            skip: 0,
            take: 1000,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setTags(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.total;
        },
        setSelectedTags(state, payload) {
            state.selectedItems = payload;
        },
        setTagPage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getTags');
        },
        setTagTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getTags');
        },
    },
    actions: {
        async getTags(store) {
            store.state.loading = true;
            var res = await axios.post('segmentation/listtags', {
                ...store.state.filter,
            });
            store.state.loading = false;
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            }
            return store.commit('setTags', res.data.data);
        },

        async deleteTag(store, payload) {
            var res = await axios.post('segmentation/deletetag', {
                id: payload,
            });
            // if (res.data.alert.hasError) {
            //     payload.context.$message.error(res.data.alert.message);
            // } else {
            //     store.state.items.splice(payload.index, 1);
            //     payload.context.$message.success(res.data.alert.message);
            //     if (store.state.items.length == 0 && store.state.filter.page != 1) {
            //         this.commit('setTagPage', store.state.filter.page - 1);
            //     }
            //     store.state.filter.total = store.state.filter.total - 1;
            // }
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async getTagOne(store, payload) {
            var res = await axios.post('segmentation/gettag', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            }
            return res;
        },
    },
    getters: {
        getTagsList: (state) => state.items,
    },
};
export default tags;


// WEBPACK FOOTER //
// ./src/store/tags.js